import _regeneratorRuntime from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import React from 'react';
import { getDefaultCountryCode } from '@jutro/locale';
import loadable from '@loadable/component';
var IntlPhoneNumberInputLazy = loadable(false ? function _callee() {
  return _regeneratorRuntime.async(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", require('./IntlPhoneNumberInput').IntlPhoneNumberInput);

        case 1:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, null, Promise);
} : function () {
  return import('./IntlPhoneNumberInput').then(function (el) {
    return el.IntlPhoneNumberInput;
  });
});
var IntlPhoneNumberReadOnlyLazy = loadable(false ? function _callee2() {
  return _regeneratorRuntime.async(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", require('./values/PhoneNumberValue').PhoneNumberValue);

        case 1:
        case "end":
          return _context2.stop();
      }
    }
  }, null, null, null, Promise);
} : function () {
  return import('./values/PhoneNumberValue').then(function (el) {
    return el.PhoneNumberValue;
  });
});
export var IntlPhoneNumberInputLazyLoaded = function IntlPhoneNumberInputLazyLoaded(props) {
  return React.createElement(IntlPhoneNumberInputLazy, props);
};
export var IntlPhoneNumberReadOnlyLazyLoaded = function IntlPhoneNumberReadOnlyLazyLoaded(props) {
  return React.createElement(IntlPhoneNumberReadOnlyLazy, props);
};
export function getDefaultCountry(defaultCountry) {
  var initialCountryCode = 'US';

  if (getDefaultCountryCode() && !defaultCountry) {
    initialCountryCode = getDefaultCountryCode();
  }

  if (defaultCountry) {
    initialCountryCode = defaultCountry;
  }

  return initialCountryCode;
}